import { render, staticRenderFns } from "./AlertsTemplate.vue?vue&type=template&id=6fdc6ba8&scoped=true"
import script from "./AlertsTemplate.vue?vue&type=script&lang=js"
export * from "./AlertsTemplate.vue?vue&type=script&lang=js"
import style0 from "./AlertsTemplate.vue?vue&type=style&index=0&id=6fdc6ba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc6ba8",
  null
  
)

export default component.exports